export enum TableCall {
  ACTIVE = "ACTIVE",
  PAUSE = "PAUSE",
}
